import { ALERT_SEVERITY, ALERT_DURATION } from "Util/alerts";
import { BP } from "Responsive/breakpoint";
import { isAtLeast } from "Responsive/manager";

export const defaultAlertDuration = ALERT_DURATION.long;

/**
 * The break point at which point the capsules will transition to wide view.
 */
export const WIDE_BP = BP.sm;

export default {
    inject: {
        viewport: {
            from: "viewport",
            default: null
        }
    },
    props: {
        ProgramId: { type: String, required: true },
        ProjectId: { type: String, required: true },
        FormId: { type: String, required: false, default: null },
        FormVersionId: { type: String, required: false, default: null },
        projectNumber: { type: String, required: true },
        currentUserId: { type: String, required: true },
        id: { type: String, required: true },
        title: { type: String, required: false },
        isAdminPage: { type: Boolean, required: false, default: false },
        isReadOnlyUser: { type: Boolean, required: false, default: false }
    },
    data() {
        return {
            expanded: true,
            showAlert: false,
            alertSeverity: ALERT_SEVERITY.info,
            alertMessage: null,
            alertDuration: defaultAlertDuration
        };
    },
    computed: {
        capsuleBinder() {
            return {
                id: this.id,
                title: this.title,
                shown: this.expanded,
                saveState: true,
                stateKey: this.id
            };
        },
        capsuleListeners() {
            return {
                "update:shown": this._onCapsuleToggled
            };
        },
        wideView() {
            return isAtLeast(this.viewport, WIDE_BP);
        }
    },
    methods: {
        /**
         * Get a URL for a page that's considered a child of the main Admin/Landing page
         * where the capsule is located. The current FormId will be appended if present
         * @param {*} baseUrl
         */
        _getChildPageUrl(baseUrl) {
            const formIdParam = this.FormId ? `&FormId=${this.FormId}` : "";
            return baseUrl + formIdParam;
        },
        _onCapsuleToggled(isVisible) {
            this.expanded = isVisible;
        },
        _showOperationResultAlert(message, severity, duration) {
            this.alertMessage = message;
            this.alertSeverity = severity;
            this.alertDuration = duration != null ? duration : defaultAlertDuration;
            this.showAlert = true;
        }
    }
};
